export function normalizeCount(value: number, fallback: number): number {
  if (!Number.isFinite(value)) return fallback

  return Math.max(fallback, Math.round(value))
}

export function parseCountInput(raw: string): number | null {
  const trimmed = raw.trim()

  if (!/^\d+$/.test(trimmed)) return null

  const parsed = Number(trimmed)

  if (!Number.isInteger(parsed)) return null

  return parsed
}

export function getCountError(raw: string, parsed: number | null, min: number): string | null {
  const trimmed = raw.trim()

  if (trimmed === '') return 'Enter a valid number'
  if (parsed == null) return 'Invalid number'
  if (parsed < min) return 'Invalid number'

  return null
}
